module.exports = __webpack_public_path__ + "static/img/zx.7752c04.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/zx.jpg
// module id = DPnL
// module chunks = 1